import * as React from "react";
import Icon from "../Icon";
import styled from "styled-components";
import posed, { PoseGroup } from "react-pose";
import { mergeStyles } from "../../util";

const Base = styled.div`
  position: relative;
  cursor: pointer;
`;

const IconWrapper = posed.div({
  enter: { scale: 1, rotate: 0 },
  exit: { scale: 0, rotate: -30 }
});

type Props = {
  style?: React.CSSProperties;
  className?: string;
  value?: boolean;
  onClick?: (value: boolean) => void;
  size?: number;
};

function AddToCheckToggle({
  value,
  className,
  style,
  size = 30,
  onClick
}: Props) {
  return (
    <Base
      style={mergeStyles({ width: size, height: size }, style)}
      className={className}
      onClick={() => onClick && onClick(!value)}
    >
      <PoseGroup>
        {value ? (
          <IconWrapper key="done" withParent={false}>
            <Icon name="done" c={["success", 4]} size={size} />
          </IconWrapper>
        ) : (
          <IconWrapper key="add" withParent={false}>
            <Icon name="add" c={["grey", 4]} size={size} />
          </IconWrapper>
        )}
      </PoseGroup>
    </Base>
  );
}

export default AddToCheckToggle;
